import styled from 'styled-components';

export const NewStripContainer = styled.div`
  background: ${(props) => (props.bgColor ? props.bgColor : '#000')};
  padding: 8px 0;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  box-sizing: border-box;
  height: 32px;
  padding-left: ${(props) => (props.leftPadding ? '50px' : '')};
  font-weight: ${(props) => (props.showNewUi ? '600' : '')};

  .marquee {
    display: flex;
    white-space: nowrap;
    color: ${(props) => (props.textColor ? props.textColor : '#fff')};
    font-size: clamp(12px, 2vw, 14px);
    @media (min-width: 720px) {
      text-align: center;
      justify-content: center;
    }
  }

  .marquee-content {
    display: inline-flex;
    animation: ${(props) =>
      props.showNewUi ? 'none' : 'scrollNew 10s linear infinite'};
    margin: ${(props) => (props.showNewUi ? 'auto' : '')};
    @media (min-width: 720px) {
      animation: none;
      .hideForDesktop {
        display: none;
      }
    }
  }

  .marquee-content span {
    padding-right: ${(props) => (props.showNewUi ? '0px' : '50px')};
    padding-left: ${(props) => (props.showNewUi ? '0px' : '')};
  }
  @keyframes scrollNew {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  .newOfferStrip {
    display: flex;
    align-items: center;
    font-family: Montserrat;
  }

  .copyCodeBtn {
    display: flex;
    align-items: center;
    border: 1px solid #fff;
    border-radius: 4px;
    margin-left: 8px;
    font-size: 10px;
    background-color: #02913a;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  padding: 2px 6px 6px;
  gap: 12px;
  width: 100%;
  position: fixed;
  transition: all 0.3s linear;
  z-index: ${(props) => (props.showPopup ? '1' : '997')};
  display: ${(props) => (!props.disable ? 'none' : '')};
  top: ${(props) => (props.showHeader == '-56px' ? '-70px' : '64px')};
  background: #fffcf5;
  .imageAndtext {
    flex-basis: 50%;
    position: relative;
    img {
      position: absolute;
      width: 100%;
    }
  }
  .button {
    background: #f0f0f0;
    color: #707070;
    font-weight: 500;
    width: 100%;
    padding: 14px 12px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    border-radius: 8px;
    flex-basis: 50%;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    p {
      font-size: 15px;
    }
  }
  .disable {
    background: #fff;
    background-image: url(${(props) => props.image});
    background-repeat: no-repeat;
    background-position: center;
    color: #fff;
  }
  @media (min-width: 720px) {
    display: none;
  }
  .opacity {
    opacity: 0.4;
  }
`;
